import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "KRISummarySubmissionGlobal" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
